import dayjs from 'dayjs';

const numberFormat = new Intl.NumberFormat('en-NZ', { maximumFractionDigits: 0 });
const moneyFormat = new Intl.NumberFormat('en-NZ', {
  style: 'currency',
  currency: 'NZD',
  maximumFractionDigits: 0,
});

export const litres = (value) => (
  value == null || Number.isNaN(Number(value)) ? '—' : `${numberFormat.format(value)} L`
);

export const number = (value) => (
  value == null || Number.isNaN(Number(value)) ? '—' : numberFormat.format(value)
);

export const money = (value) => (
  value == null || Number.isNaN(Number(value)) ? '—' : moneyFormat.format(value)
);

export const weeks = (value) => {
  if (value == null) return '—';
  if (value >= 104) return '104+ wk';
  return `${Number(value).toFixed(1)} wk`;
};

export const WEEKS_PER_MONTH = 52 / 12;

export const months = (value) => {
  if (value == null) return '—';
  if (value >= 104) return '24+ mo';
  const n = value / WEEKS_PER_MONTH;
  const text = n < 10 ? n.toFixed(1) : String(Math.round(n));
  return `${text} mo`;
};

export const date = (value) => (value ? dayjs(value).format('ddd D MMM YYYY') : '—');

export const shortDate = (value) => (value ? dayjs(value).format('D MMM') : '—');

export const month = (value) => (value ? dayjs(value).format('MMM YY') : '—');

export const STATUS = {
  urgent: { color: 'red', label: 'Brew now' },
  brew_soon: { color: 'orange', label: 'Brew soon' },
  overstock: { color: 'purple', label: 'Over max cover' },
  ok: { color: 'green', label: 'OK' },
  excluded: { color: 'default', label: 'Excluded' },
};

export const URGENCY = {
  urgent: { color: 'red', label: 'ASAP' },
  soon: { color: 'orange', label: 'Within 2 weeks' },
  planned: { color: 'blue', label: 'Planned' },
};

export const METHOD = {
  arima_ensemble: { color: 'green', label: 'ARIMA ensemble' },
  fallback: { color: 'gold', label: 'Short History' },
  fallback_new: { color: 'volcano', label: 'New Beer' },
};

export const BREW_STATUS = {
  planned: { color: 'blue', label: 'Planned' },
  brewing: { color: 'geekblue', label: 'Brewing' },
  packaged: { color: 'green', label: 'Packaged' },
  cancelled: { color: 'default', label: 'Cancelled' },
};

/** "1,805 × 4x6 slab (Beer BOX 4 x 6 slab)" style label for a pack-split line. */
export const packLine = (p) => (
  p.viaMix
    ? `${number(p.units)} × ${p.viaMix} (${litres(p.litres)} for mix packs)`
    : `${number(p.units)} × ${p.unit || p.sku}`
);
